module.exports = __webpack_public_path__ + "h5/img/loading3.3d0c2b36.gif";